var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 0.895,
    d: "M11.642 7.376c-5.959 0-8.976 4.51-10.118 7.805-.147.422.424.716.773.428 2.951-2.43 7.303-3.08 9.345-3.08v3.302c0 .376.46.57.74.313l5.979-5.468a.42.42 0 0 0 .02-.608l-5.979-6.197c-.273-.283-.76-.095-.76.294z"
  })));
};
export default SvgShare;